import { Capacitor } from '@capacitor/core';
import { isPlatform as ionicIsPlatform } from '@ionic/react';

// Replacement for isPlatform() function from ionic/react:
// isPlatform('capacitor') always returns false in ionic 7
// (fixed in ionic 8, so we can remove this when we upgrade)
export const isPlatform = (platform: Parameters<typeof ionicIsPlatform>[0]) => {
    if (platform === 'capacitor') {
        return Capacitor.isNativePlatform();
    } else {
        return ionicIsPlatform(platform);
    }
};
